// @flow
import client from '../../client'

// Types
import type { PrebookRecommendation } from '../../api_types'
import type { Recommendation } from '../../models/search'

export type Options = {
  search_id: string,
}

// API Endpoints
export const RECOMMENDED_TRIP_ENDPOINT = '/recommendations/'

/**
 * Returns the recommended trip for a search
 * @param  {Object} data Trip search data
 * @param  {string} data.session_id Trip search session ID.
 * @return {Promise|Error} A resolved Promise with the recommended trip id and rules
 *                         or Rejected with an Error.
 */
export const getRecommended = (data: Options): Promise<?Recommendation> => {
  const { search_id } = data
  return client
    .get(RECOMMENDED_TRIP_ENDPOINT, { query: { search_id } })
    .then((response: PrebookRecommendation) => ({
      trip_id: response.result_id,
      tags: response.tags,
    }))
    .catch(() => null)
}

export default getRecommended
